import { Typography } from 'antd';
import React from 'react';
import { startCase } from 'es-toolkit';
import { getCategoryIcon } from '../../../Assets/CommonTenant/categoryIcons';
import { ReactComponent as RightArrow } from '../../../Assets/CommonTenant/rightCircle-arrow.svg';
import {
  formatToINR,
  getNudgeDescription,
  nudgesLogo,
} from '../../../Utils/utils';
import styles from './index.module.css';

const NudgeItem: React.FC<{
  nudge: any;
  isNotClickable?: boolean;
}> = ({ nudge, isNotClickable }) => {
  const CategoryIcon = getCategoryIcon(nudgesLogo[nudge.category] || 'OTHERS');

  return (
    <div className={styles.insightContainer}>
      <div style={{ display: 'flex', gap: 8, flex: 1 }}>
        <div
          style={{
            width: 24,
            height: 24,
            background: 'var(--ct-bg-card)',
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CategoryIcon style={{ height: 16, width: 16, color: 'var(--primary-color)' }} />
        </div>

        <Typography.Text
          style={{
            fontSize: 14,
            fontWeight: 600,
            flex: 1,
            color: 'var(--ct-close-icon-bg)',
          }}
        >
          {nudge.title ? nudge.title : startCase(nudge.category)}
          <Typography.Text className={styles.nudgeDiscription}>
            {nudge.body && typeof nudge.body === 'string'
              ? nudge.body
              : nudge.body && typeof nudge.body === 'object'
              ? (nudge.body.nudgeText || nudge.body.body || '')
              : getNudgeDescription(nudge).replace(
                  /₹XXX/g,
                  formatToINR(
                    nudge.parameter.filter(
                      (para: any) => para.name === 'amount'
                    ).length > 0 &&
                      nudge.parameter.filter(
                        (para: any) => para.name === 'amount'
                      )[0].value
                      ? nudge.parameter
                          .filter((para: any) => para.name === 'amount')[0]
                          .value.toString()
                      : '0'
                  )
                )}
          </Typography.Text>
        </Typography.Text>
      </div>

      {!isNotClickable && <RightArrow style={{ color: 'var(--secondary-color)' }} />}
    </div>
  );
};
export default NudgeItem;
